<div class="modal">
  <div class="modal-dialog">
    <div class="modal-content text-center">
      <div class="modal-header justify-content-center">
        <h5 class="modal-title h4">{{ 'CONFIRMATION_MODAL.title' | translate }}</h5>
      </div>
      <div class="modal-body">
        <svg-icon *ngIf="icon" [src]="icon" [svgStyle]="{ 'width.px': 80, 'height.px': 90 }"></svg-icon>
        <p [innerHTML]="message"></p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" (click)="onConfirm()">{{ 'CONFIRMATION_MODAL.yes' | translate }}</button>
        <button type="button" class="btn btn-secondary" (click)="onClose()">{{ 'CONFIRMATION_MODAL.no' | translate }}</button>
      </div>
    </div>
  </div>
</div>
